import Storage from '../utils/Storage';

/**
 *
 * @type {{set: Token.set, get: (function(): string)}}
 */
export const Token = {

    set: function( token ) {
        Storage.setValue('BastionToken',token);
    },
    get: function() {
        return Storage.getIndex('BastionToken');
    }
};